<template>
  <div class="prompt-suggetion-wrapper">
    <div class="title">{{ title }}</div>

    <div class="options-wrapper">
      <div v-for="(options, key, gIndex) in optionsGroup" :key="key">
        <div class="group-name">{{ key }}</div>

        <div
          v-for="(option, index) in options"
          class="option-item"
          :key="index"
          @click.stop="onSelectionOption(option)"
        >
          <span v-html="formatSuggestion(option.caption)"></span>
        </div>

        <hr v-if="gIndex !== Object.keys(optionsGroup).length - 1" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AskAiSuggetions',

  props: {
    title: {
      type: String,
      default: 'Vorschläge',
    },
    optionsGroup: {
      type: Object,
      default: () => {},
    },
    inputVariables: {
      type: Array,
      default: () => [],
    },
  },

  methods: {
    onSelectionOption(option) {
      this.$emit('select', option);
    },
    formatSuggestion(suggestion) {
      return suggestion.replace(/\{(.*?)\}/g, (match, varName) => {
        const found = this.inputVariables.some(
          (v) => v.name === varName.trim()
        );
        if (found) {
          return `<span class="chip">${varName}</span>`;
        } else {
          return `{${varName}}`;
        }
      });
    },
  },
};
</script>

<style scoped>
.prompt-suggetion-wrapper {
  background: white;
  box-shadow: 2px 2px 20px 0px #00000040;
  border-radius: 10px;
  padding: 16px;
  margin-top: 6px;
  width: 100%;
  max-height: 350px;
  overflow: auto;
}

.prompt-suggetion-wrapper .title {
  font-weight: 500;
  color: #000;
  font-size: 14px;
  margin-bottom: 16px;
}

.prompt-suggetion-wrapper .group-name {
  color: #9b9b9b;
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 8px;
}

.prompt-suggetion-wrapper .option-item {
  color: #000;
  font-size: 12px;
  padding: 8px 10px;
  border-radius: 10px;
  transition: all 0.2s ease-in-out;
  cursor: pointer;
}
.prompt-suggetion-wrapper .option-item:hover {
  background-color: #f4f4f4;
}

.prompt-suggetion-wrapper .option-item ::v-deep .chip {
  background: #343331;
  color: white;
  border-radius: 4px;
  padding: 2px 4px;
  display: inline-block;
  margin-right: 4px;
  margin-bottom: 2px;
}
</style>
